import {
  CHECKBOX_PRIMARY_STYLE_CHECKED,
  CHECKBOX_SECONDARY_STYLE_CHECKED,
  CHECK_BOX_STYLES,
} from "asset/base-theme";
import BaseCheckBox, { IBaseCheckBoxProps } from "component/base/BaseCheckBox";
import { IInputCommonStyleProps } from "component/interface/Input";
import { Tooltip } from "primereact/tooltip";
import React from "react";
import { INPUT_ERROR_TYPE } from "util/Constant";
import { generateClasses } from "util/Util";

interface ICheckBoxProps extends IBaseCheckBoxProps, IInputCommonStyleProps {
  customClassName?: string;
  tooltipMessage?: string;
}
const CheckBoxWithoutMemo: React.FC<ICheckBoxProps> = (props: ICheckBoxProps) => {
  const { variantType, styleObj, customClassName, tooltipMessage, ...BaseCheckBoxProps } = props;
  const getClassNames = () => {
    let styleObject = {
      ...CHECK_BOX_STYLES,
      overrideStyle: styleObj,
      overrideClasses: props.className,
      isDisabled: props.disabled,
      applyErrorStyle: props.validation && props.errorType == INPUT_ERROR_TYPE.BORDER,
      removeStyleProperty: [],
      removeClasses: [],
    };

    if (props.checked) {
      styleObject = {
        ...styleObject,
        primaryStyle: {
          ...styleObject.primaryStyle,
          ...CHECKBOX_PRIMARY_STYLE_CHECKED,
          disabled: {
            ...styleObject.primaryStyle.disabled,
            ...CHECKBOX_PRIMARY_STYLE_CHECKED.disabled,
          },
        },
        secondaryStyle: {
          ...styleObject.secondaryStyle,
          ...CHECKBOX_SECONDARY_STYLE_CHECKED,
          disabled: {
            ...styleObject.secondaryStyle.disabled,
            ...CHECKBOX_SECONDARY_STYLE_CHECKED.disabled,
          },
        },
      };
      return generateClasses(styleObject, variantType);
    } else {
      return generateClasses(styleObject, variantType);
    }
  };

  return (
    <>
      <BaseCheckBox className={getClassNames() + `${customClassName}`} {...BaseCheckBoxProps} />

      {/* For this to work properly you need to pass id where this component is used and also it should have tooltipMessage and customClassname show-tooltip should be passed for the tooltip visibility */}
      {tooltipMessage ? (
        <Tooltip
          className="dark-tooltip w-fit rounded-toastBorderRadius bg-dark-neutral-gray-800 p-3 text-center text-sm !text-dark-neutral-gray-100"
          target={`#${props.id}`}
          position={"top"}
          showDelay={70}
          hideDelay={120}
          mouseTrack
        >
          {tooltipMessage ?? ""}
        </Tooltip>
      ) : null}
    </>
  );
};

// memoization

const CheckBox = React.memo(CheckBoxWithoutMemo);
// redux wiring

// exports
export default CheckBox;
